import { useState } from "react";
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import app from "../../firebase/firebaseConfig";
import { Link } from "react-router-dom";

function Register() {
    const auth = getAuth(app);
    const db = getFirestore(app);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
    });

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        try {
            // Création du compte
            const userCredential = await createUserWithEmailAndPassword(
                auth,
                formData.email,
                formData.password
            );
            const user = userCredential.user;

            // Sauvegarde des infos dans Firestore
            await setDoc(doc(db, "users", user.uid), {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                role: "client", // rôle défini ici
                createdAt: new Date(),
            });


            // Envoi du mail de vérification
            await sendEmailVerification(userCredential.user);
            setMessage("Un email de vérification a été envoyé. Vérifiez vos spams si vous ne le voyez pas.");

        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-body">
                            <h2 className="text-center mb-4">Créer un compte</h2>
                            <form onSubmit={handleRegister}>
                                <div className="mb-3">
                                    <label className="form-label">Prénom</label>
                                    <input type="text" name="firstName" className="form-control"
                                        value={formData.firstName} onChange={handleChange} required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Nom</label>
                                    <input type="text" name="lastName" className="form-control"
                                        value={formData.lastName} onChange={handleChange} required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input type="email" name="email" className="form-control"
                                        value={formData.email} onChange={handleChange} required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Téléphone</label>
                                    <input type="tel" name="phone" className="form-control"
                                        value={formData.phone} onChange={handleChange} required />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Mot de passe</label>
                                    <input type="password" name="password" className="form-control"
                                        value={formData.password} onChange={handleChange} required />
                                </div>

                                <button type="submit" className="btn btn-primary w-100">
                                    S’inscrire
                                </button>
                            </form>

                            {/* Alertes Bootstrap */}
                            {error && <div className="alert alert-danger mt-3">{error}</div>}
                            {message && (
                                <div className="alert alert-info mt-3">
                                    {message}
                                    <br />
                                    <small>Si vous n’avez rien reçu, vérifiez vos spams ou cliquez sur “Renvoyer” dans la page Vérification.</small>
                                </div>
                            )}
                            <button
                                className="btn btn-secondary mt-3"
                                onClick={() => sendEmailVerification(auth.currentUser)}
                            >
                                Renvoyer l’email de vérification
                            </button>
                            <p className="text-center text-muted small mt-3 mb-0">
                                Pas encore de compte ?{" "}
                                <Link to="/login" className="fw-bold text-decoration-none"
                                    style={{ color: "#6c63ff" }}>
                                    connectez-vous
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Register;
